'use client';
import { createContext, FC, ReactNode, useContext } from 'react';
import { TypeAccountSettingsData } from '@/pages/[locale]/account/settings';
import { TypeAddAChildPageData } from '@/pages/[locale]/account/settings/add-a-child';
import { TypeEditChildPageData } from '@/pages/[locale]/account/settings/edit-child/[slug]';
import { TypeSubscriberShopPageData } from '@/pages/[locale]/account/subscriber-shop';
import { TypeSubscriberShopFamilyPageData } from '@/pages/[locale]/account/subscriber-shop/family';
import { TypeReplacementPartsProductsPageData } from '@/pages/[locale]/account/replacement-parts';
import { TypeReplacementPartsComponentsPageData } from '@/pages/[locale]/account/replacement-parts/[product]';
import { TypeReplacementPartsSubcomponentsPageData } from '@/pages/[locale]/account/replacement-parts/[product]/[component]';
import { TypePlayKitsPageData } from '@/app/[locale]/(shop)/account/subscriptions/fetchPageData';

// introduce union type for new page data options as they arise
type PageDataContextValue =
  | TypeAccountSettingsData
  | TypeAddAChildPageData
  | TypeEditChildPageData
  | TypeSubscriberShopPageData
  | TypeSubscriberShopFamilyPageData
  | TypeReplacementPartsProductsPageData
  | TypeReplacementPartsComponentsPageData
  | TypeReplacementPartsSubcomponentsPageData
  | TypePlayKitsPageData
  | undefined;

interface PageDataProps {
  children: ReactNode;
  data?: PageDataContextValue;
}

const PageDataContext = createContext({} as PageDataContextValue);

export const usePageData = () => useContext(PageDataContext);

export const PageDataProvider: FC<PageDataProps> = ({ data, children }) => {
  return (
    <PageDataContext.Provider value={data}>{children}</PageDataContext.Provider>
  );
};
